module.exports = "/_next/static/images/basketballIcon@3x-dfa7519c2f30371ab675c52a493636eb.png";